import { Select, MenuItem, FormControl } from "@mui/material";

const MySelect = ({ value, onChange, listItem }) => {
  const handleClick = (event) => {
    event.stopPropagation(); // Prevent bubbling to parent
  };

  if (!Array.isArray(listItem) || listItem.length === 0) {
    return null;
  }
  return (
    <FormControl sx={{ width: "100%" }} onClick={handleClick}>
      <Select
        labelId="select-label"
        id="select"
        size="small"
        value={value}
        onChange={onChange}
        sx={{
          "& .MuiSelect-select": {
            textAlign: "center",
          },
        }}
      >
        {listItem.map((item) => (
          <MenuItem key={item.value} value={item.label}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MySelect;
